(function() {
  function initFaqSection(section) {
    if (!section) return;

    const faqHeaders = section.querySelectorAll('.ctr-faq__header');

    faqHeaders.forEach((header) => {
      header.addEventListener('click', function() {
        const item = this.closest('.ctr-faq__item');
        const isActive = item.classList.contains('ctr-faq__item--active');
        
        // Close all items
        section.querySelectorAll('.ctr-faq__item').forEach((otherItem) => {
          otherItem.classList.remove('ctr-faq__item--active');
          otherItem.querySelector('.ctr-faq__header').setAttribute('aria-expanded', 'false');
        });

        // Toggle current item
        if (!isActive) {
          item.classList.add('ctr-faq__item--active');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // Initialize all FAQ sections on page load
  document.querySelectorAll('.ctr-faq').forEach(initFaqSection);

  // Support for Shopify section rendering (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.ctr-faq');
    if (section) initFaqSection(section);
  });
})();
